export { default } from './ObservationSummary.component';
